import { Create, useSelect, useForm } from "@refinedev/antd";
import { Form, Input, Select, Tag, Space, Row, Col } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { BankOutlined, PhoneOutlined, LinkOutlined } from "@ant-design/icons";

import { IShipco, IShipcoGroup } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const ShipcoGroupCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IShipcoGroup>({ redirect: "list" });

  const { selectProps } = useSelect<IShipco>({
    resource: "shipco",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: {
      mode: "server"
    }
  });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "setup new shipping company group",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Group Registration"
            subtitle="Legal registration details"
            icon={<BankOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Registration Name"
                name="registrationName"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Registration Number" name="registrationNumber">
                <Input />
              </Form.Item>
              <Form.Item label="GST Number" name="gstNumber">
                <Input />
              </Form.Item>
              <Form.Item label="Accreditation Number" name="accreditationNumber">
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <FormSection
                title="Contact Information"
                subtitle="Group contact details"
                icon={<PhoneOutlined />}
              >
                <FormFieldGrid columns={1}>
                  <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Communication Email"
                    name="email"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </FormFieldGrid>
              </FormSection>
            </Col>

            <Col xs={24} lg={12}>
              <FormSection
                title="Parent Association"
                subtitle="Link to parent company"
                icon={<LinkOutlined />}
              >
                <Form.Item
                  label="Parent Shipco"
                  name={["shipco", "id"]}
                  rules={[{ required: true }]}
                >
                  <Select {...selectProps} />
                </Form.Item>
              </FormSection>
            </Col>
          </Row>
        </Space>
      </Form>
    </Create>
  );
};
